<template>
  <div>
    <v-btn icon @click="openHelpModal = true">
      <v-icon color="primary" class="material-icons-outlined">
        info
      </v-icon>
    </v-btn>
    <stopping-criteria-help-modal :open.sync="openHelpModal" />
  </div>
</template>

<script>
import StoppingCriteriaHelpModal from './StoppingCriteriaHelpModal';

export default {
  name: 'StoppingCriteriaHelpButton',
  components: {
    StoppingCriteriaHelpModal,
  },
  data: () => ({
    openHelpModal: false,
  }),
};
</script>
